export default __webpack_public_path__ + "static/media/alexanderjacuzzi_thumb.e9c39fca.jpg";